export const SERVICE_TEXT_MAX_LENGTH = 1000
